import { useRequiredContext } from "@redotech/react-util/context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { createContext, memo } from "react";

export interface MarketingCloudStatuses {
  marketingCloudEnabled: boolean;
  emailSmsEnabled: boolean;
  orderTrackingEnabled: boolean;
  returnTrackingEnabled: boolean;
  tnplEnabled: boolean;
  reviewsEnabled: boolean;
}

export const MarketingCloudStatusesContext = createContext<
  MarketingCloudStatuses | undefined
>(undefined);

export const MarketingCloudStatusesProvider = memo(
  function MarketingCloudStatusesProvider({
    children,
  }: {
    children: React.ReactNode;
  }) {
    const team = useRequiredContext(TeamContext);
    const settings = team.settings;

    const emailSmsEnabled = !!settings.marketing?.enabled;
    const orderTrackingEnabled = !!settings.orderTracking?.enabled;
    const returnTrackingEnabled = !!settings.returns?.enabled;
    const tnplEnabled = !!settings.tnpl?.enabled;
    const reviewsEnabled = !!settings.reviews?.enabled;

    const marketingCloudEnabled =
      emailSmsEnabled ||
      orderTrackingEnabled ||
      returnTrackingEnabled ||
      tnplEnabled ||
      reviewsEnabled;

    const marketingCloudStatuses = {
      marketingCloudEnabled,
      emailSmsEnabled,
      orderTrackingEnabled,
      returnTrackingEnabled,
      tnplEnabled,
      reviewsEnabled,
    };

    return (
      <MarketingCloudStatusesContext.Provider value={marketingCloudStatuses}>
        {children}
      </MarketingCloudStatusesContext.Provider>
    );
  },
);

export { default as MARKETING_ICON } from "@redotech/redo-icons/announcement-03.svg";
export { default as MARKETING_ICON_FILLED } from "@redotech/redo-icons/announcement-03_filled.svg";
export { default as AUTOMATIONS_ICON } from "@redotech/redo-icons/dataflow-03.svg";
export { default as AUTOMATIONS_ICON_FILLED } from "@redotech/redo-icons/dataflow-03_filled.svg";
export { default as ORDER_TRACKING_ICON } from "@redotech/redo-icons/marker-pin-02.svg";
export { default as ORDER_TRACKING_ICON_FILLED } from "@redotech/redo-icons/marker-pin-02_filled.svg";
export { default as REVIEWS_ICON } from "@redotech/redo-icons/star-01.svg";
export { default as REVIEWS_ICON_FILLED } from "@redotech/redo-icons/star-01_filled.svg";
export { default as LOYALTY_ICON } from "@redotech/redo-icons/trophy-01.svg";
export { default as LOYALTY_ICON_FILLED } from "@redotech/redo-icons/trophy-01_filled.svg";
